import { render, staticRenderFns } from "./NewslettersForm.vue?vue&type=template&id=5ff8f3d4&scoped=true&"
import script from "./NewslettersForm.vue?vue&type=script&lang=js&"
export * from "./NewslettersForm.vue?vue&type=script&lang=js&"
import style0 from "./NewslettersForm.vue?vue&type=style&index=0&id=5ff8f3d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff8f3d4",
  null
  
)

export default component.exports